import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { getColorShade, getSizeBy } from '../../../src/styled/utils';
import { OverlineStyles } from '../typography';
import { Icon } from '../icon';
export const Crumbs = styled.nav ``;
export const List = styled.ol `
  display: flex;
  gap: ${getSizeBy(1.5)};
  padding: 0;
  list-style: none;
`;
export const StyledDivider = styled(Icon).attrs({ name: 'arrow_forward' }) `
  width: ${getSizeBy(2.5)};
  height: ${getSizeBy(2.5)};
  margin-left: ${getSizeBy(1)};
  fill: ${getColorShade('onSurface', 'lowEmphasis')};
`;
export const ListElement = styled.li `
  position: relative;
  display: flex;
  align-items: center;
  color: ${getColorShade('onSurface', 'lowEmphasis')};
  ${OverlineStyles}

  a:hover,
  &:last-child,
  &.last-item {
    color: ${getColorShade('onSurface', 'highEmphasis')};
  }
`;
export const ListLink = styled(Link) `
  color: inherit;
  text-decoration: none;
`;
